import { EditorState } from 'draft-js';

export const getTextEditor = state => state.textEditor;
export const getTextEditorStateByKey = (state, key) => getTextEditor(state)[key] || EditorState.createEmpty();



// WEBPACK FOOTER //
// ./app/selectors/text-editor-selectors.js